import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ApiService } from './api.service';
import { BehaviorSubject, Observable, filter, take } from 'rxjs';
import { LocaleDirection } from '@core/enums';
import { CookieService } from './cookie.service';

@Injectable({
	providedIn: 'root',
})
export class LocaleService {
	constructor(private router: Router, private activatedRoute: ActivatedRoute, private api: ApiService, private cookie: CookieService) {}

	private readonly _localeDirection$ = new BehaviorSubject<LocaleDirection>(LocaleDirection.RTL);

	get localeDirection$(): Observable<LocaleDirection> {
		return this._localeDirection$.asObservable();
	}

	getLocale() {
		return localStorage.getItem('lang') || '';
	}

	setLocaleDirection(direction: LocaleDirection): void {
		this._localeDirection$.next(direction);
	}

	setLanguage(api: ApiService, lang: string): void {
		localStorage.setItem('lang', lang);
		this.cookie.set('lang', lang);

		const translationsFormData: FormData = new FormData();
		translationsFormData.set('lang', lang);

		api.getTranslations(translationsFormData).subscribe((res) => {
			this.lang = lang;
			this.translations = res['response'];
		});
	}

	initialize() {
		this.router.events
			.pipe(
				filter((event) => event instanceof NavigationEnd),
				take(1)
			)
			.subscribe(() => {
				var sel_lang = this.activatedRoute.snapshot.firstChild?.paramMap.get('lang');
				console.log(`Initialize:The selected language:${sel_lang}`);
				if (sel_lang === null) return;
				const supportedLanguages = ['en', 'ar', 'ku']; // List of supported language codes
				if (supportedLanguages.includes(sel_lang)) {
					if (this.lang !== sel_lang) {
						this.setLanguage(this.api, sel_lang);
					}
					console.log(`Navigate to /${sel_lang}`);
				} else {
					if (this.lang !== 'en') {
						this.setLanguage(this.api, 'en');
						console.log(`English /${sel_lang}`);
					}
				}
			});
	}

	lang: string;
	translations: Object;
}
